import { StaticImage } from '@/common/constants/displateRoutes';
import {
  TrustpilotReviewStarsWrapper,
  TrustPilotStar,
} from '@/modules/ProductPage/components/HeroSection/components/HeroOptions/components/TrustpilotReviews/TrustpilotReviews.styled';

export const MAX_TRUSTPILOT_STARS = 5;

export interface TrustPilotStarProps {
  opacityValue: number;
  filter: string;
}

interface TrustpilotReviewStarsProps {
  starCount: number;
  trustScore?: number;
}

const TrustpilotReviewStars = ({ starCount, trustScore }: TrustpilotReviewStarsProps) => {
  const imgSrc = StaticImage('/icons/socials/trustpilot_star.svg');
  const createActiveStars = () => {
    return Array.from({ length: starCount }, (_, index) => (
      <TrustPilotStar
        alt={'Trustpilot star'}
        data-testid={'active-star'}
        filter={'none'}
        key={index}
        opacityValue={1}
        src={imgSrc}
      />
    ));
  };
  const createInactiveStars = () => {
    return Array.from({ length: MAX_TRUSTPILOT_STARS - starCount }, (_, index) => (
      <TrustPilotStar
        data-testid={'inactive-star'}
        filter={'saturate(0)'}
        key={starCount + index}
        opacityValue={0.35}
        src={imgSrc}
      />
    ));
  };

  return (
    <TrustpilotReviewStarsWrapper>
      {trustScore && (
        <span>
          {trustScore}/{MAX_TRUSTPILOT_STARS}
        </span>
      )}
      {createActiveStars()}
      {createInactiveStars()}
    </TrustpilotReviewStarsWrapper>
  );
};

export default TrustpilotReviewStars;
